import { useEffect } from 'react';
import { bool, string, func, shape, arrayOf, number } from 'prop-types';
import { Button, CloseButton, Modal } from '@fff-web/fff-ui-shared';
import { PRODUCT_SUBS_TYPES } from '../../../../utils/constants';
import ProductInfo from '../ProductInfo/ProductInfo';
import * as styles from './ReplacementProductDetail.module.scss';

const ReplacementProductDetail = ({
  subscription,
  isOpen,
  isMobile = false,
  onCloseModal,
  onSelectedProduct,
}) => {
  const onProductSelected = (prodSubType) => {
    const newSubscription = {
      ...subscription,
      productSubType: prodSubType,
    };
    onSelectedProduct(newSubscription);
    onCloseModal();
  };

  useEffect(() => {
    if (isMobile) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [isMobile]);

  const renderContent = () => (
    <div data-testid="replacement-product-detail" className={styles.container}>
      <h1>Subscription Replacement Details</h1>
      <div className={styles.productsWrapper}>
        <ProductInfo
          productInfoTitle="This item is unavailable for the season"
          name={subscription.name}
          imageUrl={subscription.variant.imageUrl}
          description={subscription.variant.description}
          sizeInfo={subscription.variant.sizeInfo}
          isReplacedProduct
          onClick={() => onProductSelected(PRODUCT_SUBS_TYPES.SUBSCRIPTION)}
        />
        <i className="far fa-exchange" />
        <ProductInfo
          productInfoTitle="It is being replaced with..."
          name={subscription.replacementProduct?.name}
          imageUrl={subscription.replacementProduct?.variants?.[0].imageUrl}
          description={subscription.replacementProduct?.variants?.[0].description}
          sizeInfo={subscription.replacementProduct?.variants?.[0].sizeInfo}
          onClick={() => onProductSelected(PRODUCT_SUBS_TYPES.REPLACEMENT)}
        />
      </div>
      <div className={styles.btnSection}>
        <Button onClick={onCloseModal}>OK, GOT IT!</Button>
        <small>To reject this replacement product, please cancel your subscription.</small>
      </div>
    </div>
  );

  return isMobile ? (
    isOpen && (
      <div data-testid="mobile-replacement-product-detail" className={styles.mobileContainer}>
        <div className={styles.buttonWrapper}>
          <Button onClick={onCloseModal}>
            <i className={styles.icon} />
            &nbsp;Back to My Subscriptions
          </Button>
        </div>
        {renderContent()}
      </div>
    )
  ) : (
    <Modal className={styles.replacementDetailsModal} isOpen={isOpen} onRequestClose={onCloseModal}>
      <div className={styles.modalWrapper}>
        <div className={styles.closeBtn}>
          <CloseButton onClick={onCloseModal} />
        </div>
        {renderContent()}
      </div>
    </Modal>
  );
};

ReplacementProductDetail.propTypes = {
  subscription: shape({
    name: string,
    cadenceType: string,
    quantity: number,
    nextRenewalDate: string,
    variant: shape({
      imageUrl: string,
      description: string,
      sizeInfo: string,
    }),
    isReplacementProduct: bool,
    replacementProduct: shape({
      brand: string,
      name: string,
      variants: arrayOf(
        shape({
          imageUrl: string,
          description: string,
          sizeInfo: string,
        }),
      ),
    }),
  }).isRequired,
  isOpen: bool.isRequired,
  isMobile: bool,
  onCloseModal: func.isRequired,
  onSelectedProduct: func.isRequired,
};

export default ReplacementProductDetail;
